import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const BackButton = styled(Button)`
  background-color: #e05100 !important;
  color: #ffffff !important;
`;
